import { ReactNode } from 'react'
import type { SectionLinks } from '@ui/features/layout/routes'
import { BrandAssetsIcon } from '@ui/icons/BrandAssetsIcon'
import { BugIcon } from '@ui/icons/BugIcon'
import { CrvHubIcon } from '@ui/icons/CrvHubIcon'
import { DiscordIcon } from '@ui/icons/DiscordIcon'
import { DocsIcon } from '@ui/icons/DocsIcon'
import { GitHubIcon } from '@ui/icons/GitHubIcon'
import { IntegrationsIcon } from '@ui/icons/IntegrationsIcon'
import { LAFIcon } from '@ui/icons/LAFIcon'
import { NewsIcon } from '@ui/icons/NewsIcon'
import { RiskDisclaimersIcon } from '@ui/icons/RiskDisclaimersIcon'
import { SecurityIcon } from '@ui/icons/SecurityIcon'
import { TelegramCNIcon } from '@ui/icons/TelegramCNIcon'
import { TelegramIcon } from '@ui/icons/TelegramIcon'
import { TelegramRUIcon } from '@ui/icons/TelegramRUIcon'
import { XIcon } from '@ui/icons/XIcon'
import { YouTubeIcon } from '@ui/icons/YouTubeIcon'
import { t } from '@ui/lib/i18n'
import { CURVE_SOCIALS, EXTERNAL_LINKS } from '@ui/lib/resource.constants'

export type FooterLink = { label: string; href: string; icon?: ReactNode; target?: string }

export type FooterSection = { title: string; links: FooterLink[] }

export const getFooterSections = ({ legalHref, integrationsHref }: SectionLinks) => [
  {
    title: t`Community`,
    links: [
      { label: t`Twitter`, href: CURVE_SOCIALS.twitter, icon: <XIcon /> },
      { label: t`Discord`, href: CURVE_SOCIALS.discord, icon: <DiscordIcon /> },
      { label: t`Youtube`, href: CURVE_SOCIALS.youtube.en, icon: <YouTubeIcon /> },
      { label: t`Announcements`, href: CURVE_SOCIALS.telegram.announcements, icon: <TelegramIcon /> },
      { label: t`Telegram`, href: CURVE_SOCIALS.telegram.en, icon: <TelegramIcon /> },
      { label: t`Telegram (CN)`, href: CURVE_SOCIALS.telegram.cn, icon: <TelegramCNIcon /> },
      { label: t`Telegram (RU)`, href: CURVE_SOCIALS.telegram.ru, icon: <TelegramRUIcon /> },
    ],
  },
  {
    title: t`Documentation`,
    links: [
      { label: t`News`, href: EXTERNAL_LINKS.curve.news, icon: <NewsIcon /> },
      { label: t`Documentation`, href: EXTERNAL_LINKS.curve.docs, icon: <DocsIcon /> },
      { label: t`Integrations`, href: integrationsHref, icon: <IntegrationsIcon /> },
      { label: t`Github`, href: EXTERNAL_LINKS.github.curvefi, icon: <GitHubIcon /> },
      { label: t`Legal`, href: legalHref, icon: <RiskDisclaimersIcon /> },
      { label: t`Brand Assets`, href: EXTERNAL_LINKS.brand.assets, icon: <BrandAssetsIcon /> },
    ],
  },
  {
    title: t`Security`,
    links: [
      { label: t`Audits`, href: EXTERNAL_LINKS.docs.user.security.audits, icon: <SecurityIcon /> },
      { label: t`Bug Bounty`, href: EXTERNAL_LINKS.docs.user.security.bugBounty, icon: <BugIcon /> },
      { label: t`Curve Monitor`, href: EXTERNAL_LINKS.monitoring.curveMonitor, icon: <LAFIcon /> },
      { label: t`CrvHub`, href: EXTERNAL_LINKS.monitoring.crvHub, icon: <CrvHubIcon /> },
    ],
  },
]
